/**
 * Reload entity with `this.item.Id` when locale changes.
 * NOTE: this is triggered by "page-update" in App, which triggers from AppLocalisationMixin.
 */
export default {

    // mounted: function () {
    //     // this.$eventBus.$on('locale-change', this.onLocaleChange);
    // },

    // beforeDestroy: function () {
    //     // this.$eventBus.$off('locale-change', this.onLocaleChange);
    // },

    // methods: {
    //     onLocaleChange: function (locale) {
    //         // const id = this.item && this.item.Id;
    //         // this.$eventBus.$emit('entity-reload', id);
    //         // this.$eventBus.$emit('page-update');
    //     }
    // }
};
